import React, { useState, useEffect, useCallback, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, TextField, CircularProgress } from '@material-ui/core';

import ActionsAnnotations from '../../../../../store/ducks/annotations';
import useStyles from './styles';

const InputAnnotation = props => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { editNote, onCancel, onStore, notes } = props;
  const { course: courseId, lesson: lessonId } = useSelector(
    state => state.course.current,
  );
  const [loadingSend, setLoadingSend] = useState(false);
  const [value, setValue] = useState({
    text: '',
    error: false,
    editing: false,
  });

  const handleValidation = useCallback(() => {
    const isValid = !!value.text;
    setValue(oldValue => ({
      ...oldValue,
      error: !isValid,
    }));
    return isValid;
  }, [value.text]);

  const handleChange = useCallback(event => {
    const newValue = event.target.value;
    setValue({ text: newValue });
  }, []);

  const handleCancelEdit = useCallback(() => onCancel(), [onCancel]);

  const handleClearAnnotation = useCallback(() => {
    setValue({ text: '', error: false });
  }, []);

  const handleSendAnnotation = useCallback(() => {
    if (handleValidation()) {
      if (editNote) {
        dispatch(
          ActionsAnnotations.requestUpdateAnnotation(
            courseId,
            lessonId,
            editNote.id,
            value.text,
          ),
        );
      } else {
        dispatch(
          ActionsAnnotations.requestStoreAnnotation(
            courseId,
            lessonId,
            value.text,
          ),
        );
        onStore();
      }
      setLoadingSend(true);
    }
  }, [
    courseId,
    dispatch,
    editNote,
    handleValidation,
    lessonId,
    onStore,
    value.text,
  ]);

  useEffect(() => {
    if (editNote) {
      setValue(oldValue => {
        const { editing, text: oldText } = oldValue;
        return {
          text: editing || editing === undefined ? oldText : editNote.text,
          error: false,
          editing: true,
        };
      });
    }
  }, [editNote]);

  useEffect(() => {
    setLoadingSend(oldLoadingSend => {
      if (oldLoadingSend) {
        handleClearAnnotation();
        return false;
      }
      return oldLoadingSend;
    });
  }, [handleClearAnnotation, notes]);

  return (
    <Box className={`${classes.container} ${editNote ? 'edit-note' : ''}`}>
      <TextField
        className="notes-new-input"
        id="notes-new-input"
        placeholder="Escreva sua anotação sobre o conteúdo..."
        helperText={
          value.error ? 'Escreva o texto da sua anotação antes de salvar.' : ''
        }
        multiline
        variant="outlined"
        InputProps={{ classes: { root: classes.input } }}
        name="annotation"
        error={value.error}
        value={value.text}
        disabled={loadingSend}
        onChange={e => handleChange(e)}
      />
      <Box className="notes-new-actions">
        {value.text && !editNote && (
          <Button
            classes={{ root: classes.btn }}
            onClick={handleClearAnnotation}
          >
            Limpar
          </Button>
        )}
        {editNote && (
          <Button classes={{ root: classes.btn }} onClick={handleCancelEdit}>
            Cancelar
          </Button>
        )}
        <Button
          classes={{ root: classes.btn }}
          color="primary"
          onClick={handleSendAnnotation}
        >
          {loadingSend ? (
            <CircularProgress color="inherit" size={24} />
          ) : (
            'Salvar'
          )}
        </Button>
      </Box>
    </Box>
  );
};

export default memo(InputAnnotation);
